import { useBadges } from '../hooks/useBadges';
import { BadgePopup } from './BadgePopup';
import {
  IconTarget,
  IconBolt,
  IconCrown,
  IconFire,
  IconGem,
  IconStar,
  IconMedal,
} from './icons';
import type { ReactNode } from 'react';
import type { BadgeItem } from '../lib/api';
import './BadgesList.css';

const BADGE_ICONS: Record<string, ReactNode> = {
  first_project: <IconTarget size={16} />,
  vibe_coder: <IconBolt size={16} />,
  prolific: <IconCrown size={16} />,
  streak_7: <IconFire size={16} />,
  ambassador: <IconStar size={16} />,
  sponsor: <IconGem size={16} />,
  early_adopter: <IconMedal size={16} />,
};

const BADGE_ACCENTS: Record<string, string> = {
  first_project: '#c084fc',
  vibe_coder: '#a78bfa',
  prolific: '#fbbf24',
  streak_7: '#f97316',
  ambassador: '#fbbf24',
  sponsor: '#67e8f9',
  early_adopter: '#d97706',
};

interface BadgesListProps {
  badges?: BadgeItem[];
}

export function BadgesList({ badges }: BadgesListProps = {}) {
  const { badges: fetchedBadges, newBadges, loading, dismissNewBadges } = useBadges();
  const sourceBadges = badges ?? fetchedBadges;

  if (loading && !badges) return null;

  const earned = sourceBadges.filter((b) => b.earned);
  const locked = sourceBadges.filter((b) => !b.earned);
  const pendingPopup = newBadges[0] ?? null;

  return (
    <>
      <div className="badges-section">
        <div className="section-label badges-section-header" style={{ padding: '0 20px', marginBottom: 8 }}>
          Бейджи
          <span className="badges-count">
            {earned.length}/{sourceBadges.length}
          </span>
        </div>

        <div className="badges-grid" style={{ padding: '0 20px' }}>
          {earned.map((b) => (
            <div
              key={b.id}
              className="badge-item earned"
              style={
                {
                  ['--badge-accent-bg' as string]: `${BADGE_ACCENTS[b.id] ?? '#a78bfa'}18`,
                  ['--badge-accent-border' as string]: `${BADGE_ACCENTS[b.id] ?? '#a78bfa'}40`,
                } as React.CSSProperties
              }
            >
              <span className="badge-icon">{BADGE_ICONS[b.id] ?? <IconBolt size={16} />}</span>
              <span className="badge-name">{b.name}</span>
            </div>
          ))}
          {locked.map((b) => (
            <div key={b.id} className="badge-item locked">
              <span className="badge-icon">{BADGE_ICONS[b.id] ?? <IconBolt size={16} />}</span>
              <span className="badge-name">{b.name}</span>
            </div>
          ))}
        </div>
      </div>

      {pendingPopup && (
        <BadgePopup
          badgeId={pendingPopup.new_badge_id}
          name={pendingPopup.new_badge_name}
          emoji={pendingPopup.new_badge_emoji}
          icon={BADGE_ICONS[pendingPopup.new_badge_id] ?? undefined}
          onClose={dismissNewBadges}
        />
      )}
    </>
  );
}
